import { ExternalLink } from 'lucide-react';
import './QardanHasanah.css';

export default function QardanHasanah() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="relative py-20 text-white overflow-hidden" style={{ background: 'linear-gradient(135deg, #001f3f 0%, #003d66 100%)' }}>
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-10 right-20 w-64 h-64 rounded-full border-2 border-white"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

          <h1 className="font-playfair text-5xl md:text-6xl font-bold mb-4">Qardan Hasanah</h1>

        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* About Qardan Hasanah */}
        <div className="mb-16">
          <div className="bg-white border-2 border-dawoodi-navy/10 rounded-xl p-10 hover:shadow-lg transition-all">
            <h2 className="font-playfair text-3xl font-bold text-dawoodi-navy mb-6">
              About Qardan Hasanah
            </h2>
            <p className="font-poppins text-gray-700 leading-relaxed text-lg">
              Anjuman-e-Burhani of New Jersey operates Qardan Hasana scheme where many mumineen over the past years have benefited by this scheme.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="my-12 h-1 bg-gradient-to-r from-transparent via-dawoodi-gold/30 to-transparent rounded-full"></div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-dawoodi-navy to-dawoodi-navy text-white rounded-2xl p-12 text-center">
          <h3 className="font-playfair text-3xl font-bold mb-4">
            Ready to Apply?
          </h3>
          <p className="font-poppins text-lg text-white/90 mb-6 max-w-2xl mx-auto">
            Complete your Qardan Hasanah application online.
          </p>
          <a
            href="https://usa.qardanhasana.org"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 bg-dawoodi-gold text-dawoodi-navy font-bold px-8 py-4 rounded-xl hover:bg-yellow-300 transition-colors"
          >
            {/* <DollarSign className="w-5 h-5" /> */}
            <span>Apply Now</span>
          </a>
        </div>

        {/* Divider */}
        <div className="my-12 h-1 bg-gradient-to-r from-transparent via-dawoodi-gold/30 to-transparent rounded-full"></div>

        {/* Contact Section */}
        <div className="mb-16">
          <h2 className="font-playfair text-4xl font-bold text-dawoodi-navy mb-8">Contact & Resources</h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white border-2 border-dawoodi-navy/10 rounded-xl p-8 hover:border-dawoodi-gold hover:shadow-lg transition-all">
              <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-4">Questions?</h3>
              <p className="font-poppins text-gray-700 mb-4">
                If you have any questions, please contact us:
              </p>
              <div className="space-y-3 font-poppins">
                <a href="mailto:qh@njjamaat.org" className="block text-dawoodi-gold font-semibold hover:underline">
                  📧 qh@njjamaat.org
                </a>
                <a href="tel:9083311528" className="block text-dawoodi-gold font-semibold hover:underline">
                  📞 Call: 908-331-1528
                </a>
              </div>
            </div>

            <div className="bg-white border-2 border-dawoodi-navy/10 rounded-xl p-8 hover:border-dawoodi-gold hover:shadow-lg transition-all">
              <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-4">User Guide</h3>
              <p className="font-poppins text-gray-700 mb-4">
                Download the user guide to understand the application process step-by-step.
              </p>
              <a
                href="https://drive.google.com/uc?export=download&id=1Dg6pBL6VUhsHAzsYb2oLUFQpzXJGmiUZ"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-dawoodi-gold font-semibold hover:underline"
              >
                <ExternalLink className="w-4 h-4" />
                <span>Download User Guide</span>
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="my-12 h-1 bg-gradient-to-r from-transparent via-dawoodi-gold/30 to-transparent rounded-full"></div>

      </div>
    </div>
  );
}
